import { mirrorX } from "apparatus/draw";
import { Segments } from "apparatus/library/common";
import { Path, Shape } from "paper";
export class Tripod {
    render(appearance) {
        let height = appearance.height;
        let width = appearance.width;
        var graphic = new Path(Segments([[-5, height]], [[0, height - 5], [0, 5]], [[0, 5]], [[5, 0], [-5, 0]]));
        mirrorX(graphic, width / 2);
        graphic.withStroke(appearance.strokeThickness);
        var hitShape = Shape.Rectangle(graphic.strokeBounds);
        return {
            graphic: graphic,
            hitShape: hitShape,
            snapping: [
                graphic.placeable(),
                graphic.topEdgeAsPlaceableSurface(),
            ]
        };
    }
}
Tripod.properties = {
    label: "Tripod",
    defaultAppearance: {
        width: 120,
        height: 190,
        strokeThickness: "default"
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "width", label: "Width",
            min: 70, max: 180
        },
        {
            spec: "slider", key: "height", label: "Height",
            min: 30, max: 250
        },
        {
            spec: "toggle-buttons", key: "strokeThickness", label: "Appearance",
            size: "icon",
            options: [
                { icon: "k,stroke-1", label: "Default", value: "default" },
                { icon: "k,stroke-2", label: "Thick", value: "thicker" },
            ],
        }
    ],
};
